import DOMPurify from 'isomorphic-dompurify';

const RICH_HTML_DEFAULTS = {
  USE_PROFILES: { html: true },
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed']
};

const PLAIN_TEXT_DEFAULTS = {
  ALLOWED_TAGS: [],
  ALLOWED_ATTR: []
};

export function sanitizeRichHtml(html: string, options?: any): string {
  return String(DOMPurify.sanitize(html, { ...RICH_HTML_DEFAULTS, ...(options || {}) }));
}

export function sanitizePlainText(html: string, options?: any): string {
  return String(DOMPurify.sanitize(html, { ...PLAIN_TEXT_DEFAULTS, ...(options || {}) }));
}
